import ArpRegistry from '../../features/arp-registry/ArpRegistry'

export const SONG_OPENSEA_BASE_URL =
  'https://opensea.io/assets/matic/0x5428dff180837ce215c8abe2054e048da311b751'
export const STEM_OPENSEA_BASE_URL =
  'https://opensea.io/assets/matic/0x9c53114adfdfb0fdbf6a85ca7e696debd3a70193'
export const SAMPLE_OPENSEA_BASE_URL =
  'https://opensea.io/assets/matic/0x9c53114adfdfb0fdbf6a85ca7e696debd3a70193'

/** Returns the opensea link given a song index */
export const getSongOpenseaLink = async (index: number) => {
  const song = await ArpRegistry.getByIdAsync(index)
  return `${SONG_OPENSEA_BASE_URL}/${song.tokenId}`
}

/** Returns the opensea link given a stem index */
export const getStemOpenseaLink = async (index: number) => {
  const stem = await ArpRegistry.getByIdAsync(index)
  return `${STEM_OPENSEA_BASE_URL}/${stem.tokenId}`
}

/** Returns the opensea link given a sample index */
export const getSampleOpenseaLink = async (index: number) => {
  const sample = await ArpRegistry.getByIdAsync(index)
  return `${SAMPLE_OPENSEA_BASE_URL}/${sample.tokenId}`
}
